<template>
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal top" :width="width" :closable="closable">
    <div class="text-box">
      <i class="iconfont icontishi"></i>
      {{ content }}
    </div>

    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">{{ cancelText || '取消' }}</Button>
      <Button type="primary" @click="ok">{{ okText || '确定' }}</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      visible: false,
      closable: true,
      title: '',
      width: 300,
      content: '',
      okText: '', //确定按钮文本
      cancelText: '' //取消按钮文本
    };
  },
  watch: {},
  methods: {
    async open(data) {
      return new Promise((resolve, reject) => {
        this.title = data.title;
        this.content = data.content;
        this.closable = typeof data.closable == 'boolean' ? data.closable : true;
        this.width = data.width || 300;
        this.okText = data.okText;
        this.cancelText = data.cancelText;
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.visible = false;
      this.reject();
    },
    ok() {
      this.visible = false;
      this.resolve();
    },
    resolve() {},
    reject() {}
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  &.top {
    /deep/ .ivu-modal {
      top: 15vh !important;
    }
  }
  /deep/ {
    .ivu-modal-body {
      font-size: 13px;
    }
    .ivu-modal-footer {
      .ivu-btn {
        min-width: 80px;
        width: auto;
      }
    }
  }
  .text-box {
    padding: 20px 0;
    text-align: center;
    color: #515c6f;
    i {
      color: #f59853;
      font-size: 13px;
    }
  }
}
</style>
